import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Excellus Blue Cross Blue Shield",
  shortName: "Excellus BCBS",
  slug: "excellus-bcbs-insurance",
  seoTitle: "Excellus BCBS TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Excellus Blue Cross Blue Shield? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Excellus BCBS plan in Coral Springs, FL.",
  seoKeywords:
    "Excellus BCBS TMS coverage, Excellus Blue Cross TMS therapy, Excellus depression treatment Florida, Excellus BCBS mental health benefits Coral Springs FL, Excellus SAINT TMS",
  planType: "non-profit Blue Cross Blue Shield affiliate health insurance plan",
  planRegion: "upstate New York and surrounding regions",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Excellus Blue Cross Blue Shield is a non-profit independent licensee of the Blue Cross Blue Shield Association, serving members across upstate New York. Excellus BCBS plans generally include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Coverage for TMS, accelerated TMS protocols, and other advanced depression treatments depends on your specific Excellus plan type, whether the provider is in network, and documented prior treatment history.",
  officialResourceUrl: "https://www.excellusbcbs.com/",
  officialResourceLabel: "Excellus Blue Cross Blue Shield official website",
};

export const ExcellusBcbsInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default ExcellusBcbsInsurance;
